(() => {
  'use strict';

  function initProduct(root) {
    if (root.dataset.dfgReady) return;
    root.dataset.dfgReady = 'true';
    const dataElement = root.querySelector('[data-dfg-variants]');
    if (!dataElement) return;
    let variants;
    try { variants = JSON.parse(dataElement.textContent); } catch (_) { return; }

    const form = root.querySelector('[data-dfg-product-form]');
    const select = root.querySelector('[data-dfg-variant-select]');
    const price = root.querySelector('[data-dfg-price]');
    const comparePrice = root.querySelector('[data-dfg-compare-price]');
    const submit = root.querySelector('[data-dfg-add]');
    const submitTitle = root.querySelector('[data-dfg-add-title]');
    const submitSubtitle = root.querySelector('[data-dfg-add-subtitle]');
    const availability = root.querySelector('[data-dfg-availability]');
    const quantity = root.querySelector('[data-dfg-quantity]');
    const mainImage = root.querySelector('[data-dfg-main-image]');
    const count = root.querySelector('[data-dfg-photo-count]');
    const caption = root.querySelector('[data-dfg-caption]');
    const thumbs = [...root.querySelectorAll('[data-dfg-photo]')];
    const thumbnailStrip = root.querySelector('.dfg-gallery-thumbs');
    const minus = root.querySelector('[data-dfg-quantity-minus]');
    const plus = root.querySelector('[data-dfg-quantity-plus]');
    const visualTitles = [...root.querySelectorAll('[data-dfg-visual-title]')];
    const introduction = root.querySelector('[data-dfg-introduction]');
    const designName = root.querySelector('[data-dfg-design-name]');
    const designLinks = [...root.querySelectorAll('[data-dfg-design-key]')];
    const productUrl = root.dataset.dfgProductUrl || window.location.pathname;

    function cleanVariantFromUrl() {
      if (!window.history.replaceState) return;
      const url = new URL(window.location.href);
      if (!url.searchParams.has('variant')) return;
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    }

    function revealThumbnail(thumb) {
      if (!thumb || !thumbnailStrip?.scrollTo) return;
      const padding = 8;
      let left = thumbnailStrip.scrollLeft;
      let top = thumbnailStrip.scrollTop;
      if (thumb.offsetLeft < left + padding) left = thumb.offsetLeft - padding;
      else if (thumb.offsetLeft + thumb.offsetWidth > left + thumbnailStrip.clientWidth - padding) {
        left = thumb.offsetLeft + thumb.offsetWidth - thumbnailStrip.clientWidth + padding;
      }
      if (thumb.offsetTop < top + padding) top = thumb.offsetTop - padding;
      else if (thumb.offsetTop + thumb.offsetHeight > top + thumbnailStrip.clientHeight - padding) {
        top = thumb.offsetTop + thumb.offsetHeight - thumbnailStrip.clientHeight + padding;
      }
      // Scroll only the thumbnail area; never move the page or keyboard focus.
      thumbnailStrip.scrollTo({ left: Math.max(0, left), top: Math.max(0, top), behavior: 'auto' });
    }

    function showImage(src, alt, thumb) {
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = src;
      mainImage.alt = alt || '';
      thumbs.forEach((button) => button.setAttribute('aria-pressed', String(button === thumb)));
      const visibleThumbs = thumbs.filter((button) => !button.hidden);
      if (count) count.textContent = thumb ? `${visibleThumbs.indexOf(thumb) + 1} / ${visibleThumbs.length}` : 'Selected option';
      if (caption) caption.textContent = thumb ? thumb.dataset.caption || '' : alt || '';
      revealThumbnail(thumb);
    }

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
      showImage(thumb.dataset.src, thumb.dataset.alt, thumb);
    }));

    function updateQuantityButtons() {
      if (!quantity) return;
      const value = Number(quantity.value);
      if (minus) minus.disabled = value <= Number(quantity.min || 1);
      if (plus) plus.disabled = quantity.max !== '' && value >= Number(quantity.max);
    }

    function changeQuantity(direction) {
      if (!quantity) return;
      if (!Number.isFinite(quantity.valueAsNumber)) quantity.value = quantity.min || '1';
      if (direction < 0) quantity.stepDown(); else quantity.stepUp();
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    minus?.addEventListener('click', () => changeQuantity(-1));
    plus?.addEventListener('click', () => changeQuantity(1));
    quantity?.addEventListener('change', updateQuantityButtons);
    quantity?.addEventListener('input', updateQuantityButtons);

    function updateVariant() {
      const variant = variants.find((item) => String(item.id) === select?.value);
      if (!variant) return;
      visualTitles.forEach((element) => { element.textContent = variant.visualTitle; });
      if (introduction) {
        introduction.textContent = variant.introduction || '';
        introduction.hidden = !variant.introduction;
      }
      if (designName) designName.textContent = variant.designName || '';
      designLinks.forEach((link) => {
        const active = link.dataset.dfgDesignKey === variant.designKey;
        link.classList.toggle('dfg-active', active);
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        link.href = active ? productUrl : link.dataset.defaultUrl;
        const linkPrice = link.querySelector('[data-dfg-design-price]');
        if (linkPrice) linkPrice.textContent = active ? variant.price : link.dataset.defaultPrice;
      });
      thumbs.forEach((thumb) => {
        if (thumb.dataset.dfgOpenKey) thumb.hidden = thumb.dataset.dfgOpenKey !== variant.designKey;
      });
      if (price) price.textContent = variant.price;
      if (comparePrice) {
        comparePrice.textContent = variant.compareAt || '';
        comparePrice.hidden = !variant.compareAt;
      }
      if (submit) submit.disabled = !variant.available;
      if (submitTitle) submitTitle.textContent = variant.available ? 'CLAIM YOUR TREASURE' : 'SOLD OUT';
      if (submitSubtitle) submitSubtitle.textContent = variant.available ? 'Add to bag' : 'Choose another option';
      if (availability) availability.textContent = variant.available ? 'Available' : 'This option is sold out.';
      if (quantity) {
        quantity.min = String(variant.quantityMin || 1);
        quantity.step = String(variant.quantityStep || 1);
        quantity.max = variant.quantityMax == null ? '' : String(variant.quantityMax);
        const minimum = Number(quantity.min);
        const step = Number(quantity.step);
        const current = Number(quantity.value) || minimum;
        let next = minimum + Math.max(0, Math.floor((current - minimum) / step)) * step;
        if (quantity.max !== '') next = Math.min(next, Number(quantity.max));
        quantity.value = String(next);
      }
      if (variant.image) {
        const thumb = thumbs.find((button) => !button.hidden && button.dataset.imageId === String(variant.image.id));
        showImage(variant.image.src, variant.image.alt || variant.title, thumb);
      } else {
        const openThumb = thumbs.find((button) => !button.hidden && button.dataset.dfgOpenKey === variant.designKey);
        if (openThumb) showImage(openThumb.dataset.src, openThumb.dataset.alt, openThumb);
      }
      updateQuantityButtons();
      cleanVariantFromUrl();
    }

    select?.addEventListener('change', updateVariant);
    window.addEventListener('popstate', () => {
      const id = new URL(window.location.href).searchParams.get('variant');
      if (id && variants.some((variant) => String(variant.id) === id) && select) {
        select.value = id;
        updateVariant();
      }
    });
    form?.addEventListener('submit', (event) => {
      const variant = variants.find((item) => String(item.id) === select?.value);
      if (!variant?.available) event.preventDefault();
      // Available purchases use the native Shopify form submission and cart redirect.
    });
    updateVariant();
  }

  function init(scope) {
    if (scope.matches?.('[data-dfg-product]')) initProduct(scope);
    scope.querySelectorAll('[data-dfg-product]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
